










































































































































































































































import _ from "lodash";
import { MaterielApi } from "../api/MaterielApi";
import EquipementDetailModal from "./EquipementDetailModal.vue";
import EntretienEditModal from "./EntretienEditModal.vue";

export default {
    name: "MaintenancePanel",
    components: { EquipementDetailModal, EntretienEditModal },
    props: {
        refreshKey: Number,
    },
    data() {
        return {
            MaterielApi: new MaterielApi(),
            equipements: [],
            entretiens: [],
            loading: false,
            showDetailModal: false,
            showEntretienModal: false,
            selectedEquipement: null,
        };
    },
    computed: {
        /** Entretiens groupés par équipement, du plus récent au plus ancien. */
        entretiensParEquipement: function () {
            let groupes = _.groupBy(this.entretiens, "equipement_id");
            return _.mapValues(groupes, function (liste) {
                return _.orderBy(liste, ["date", "id"], ["desc", "desc"]);
            });
        },
        stats: function () {
            let s = { ok: 0, soon: 0, overdue: 0, in: 0, broken: 0 };
            _.forEach(this.equipements, function (eq) {
                let code = eq.maintenance ? eq.maintenance.code : "ok";
                if (eq.etat_operationnel === "broken") {
                    s.broken++;
                } else if (eq.etat_operationnel === "maintenance") {
                    s.in++;
                } else if (code === "overdue") {
                    s.overdue++;
                } else if (code === "soon") {
                    s.soon++;
                } else {
                    s.ok++;
                }
            });
            return s;
        },
        items: function () {
            let self = this;
            let list = _.map(self.equipements, function (eq) {
                let entretiens = self.entretiensParEquipement[eq.id] || [];
                return {
                    equipement: eq,
                    code: eq.maintenance ? eq.maintenance.code : "ok",
                    daysLeft:
                        eq.maintenance && eq.maintenance.days_left !== null
                            ? eq.maintenance.days_left
                            : 0,
                    entretiens: entretiens,
                    dernierEntretien: entretiens.length ? entretiens[0] : null,
                    coutTotal: _.sumBy(entretiens, function (e) {
                        return parseFloat(e.cout) || 0;
                    }),
                };
            });

            return _.sortBy(list, function (item) {
                return self.rang(item);
            });
        },
        historique: function () {
            return _.orderBy(
                this.entretiens,
                ["date", "id"],
                ["desc", "desc"]
            ).slice(0, 50);
        },
        coutCumule: function () {
            return _.sumBy(this.entretiens, function (e) {
                return parseFloat(e.cout) || 0;
            });
        },
    },
    created() {
        this.load();
    },
    methods: {
        load: function () {
            let self = this;
            self.loading = true;

            Promise.all([
                self.MaterielApi.getEquipements(),
                self.MaterielApi.getEntretiens(),
            ])
                .then(function (res) {
                    self.equipements = res[0];
                    self.entretiens = res[1];
                    self.loading = false;
                    self.rafraichirSelection();
                })
                .catch(function (error) {
                    self.loading = false;
                    self.emitError(error);
                });
        },
        rafraichirSelection: function () {
            if (!this.selectedEquipement || !this.selectedEquipement.id) {
                return;
            }
            let found = _.find(this.equipements, {
                id: this.selectedEquipement.id,
            });
            if (found) {
                this.selectedEquipement = found;
            }
        },
        /** Ordre d'affichage : HS, en retard, en maintenance, bientôt, à jour. */
        rang: function (item) {
            if (item.equipement.etat_operationnel === "broken") {
                return 1;
            }
            if (item.code === "overdue") {
                return 2;
            }
            if (item.equipement.etat_operationnel === "maintenance") {
                return 3;
            }
            if (item.code === "soon") {
                return 4;
            }
            return 5;
        },
        classeEcheance: function (code) {
            if (code === "overdue") {
                return "m-cell-overdue";
            }
            if (code === "soon") {
                return "m-cell-soon";
            }
            return "m-cell-ok";
        },
        libelleEquipement: function (equipementId) {
            let found = _.find(this.equipements, { id: equipementId });
            return found ? found.libelle : "—";
        },
        openDetail: function (equipement) {
            this.selectedEquipement = equipement;
            this.showDetailModal = true;
        },
        openEntretien: function (equipement) {
            this.selectedEquipement = equipement;
            this.showEntretienModal = true;
        },
        onEntretienSaved: function () {
            this.showEntretienModal = false;
            this.load();
            this.$emit("refresh");
        },
        onRefreshDemande: function () {
            this.load();
            this.$emit("refresh");
        },
        emitError: function (error) {
            this.$emit("toast", {
                message: _.get(
                    error,
                    "response.data.message",
                    "Une erreur est survenue"
                ),
                kind: "error",
            });
        },
    },
    watch: {
        refreshKey: function () {
            this.load();
        },
    },
};
